var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 16,
    fill: "none",
    viewBox: "-1 -1 98 16",
    id: "logo",
    y: 665,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.615 14.071h-3.003l-1.76-3.545h-6.864l-1.739 3.545h-2.957L45.178 0h2.529l6.908 14.071zm-5.644-5.55l-2.574-5.438-2.574 5.439h5.148zM2.619 2.203h9.912V0H0v14.071h2.619V7.839h5.893V5.593H2.619V2.202zm26.98 11.869h2.935l-.316-.55c-1.038-1.762-2.032-3.436-2.822-5.197 1.987-.485 3.16-1.96 3.16-4.008C32.557 1.894 30.458 0 27.794 0h-8.805v14.071h2.574V8.5h5.012c.858 1.761 1.829 3.479 2.777 5.153l.248.418zm-2.235-7.685h-5.78V2.114h5.825c1.445 0 2.348.837 2.348 2.158.023 1.343-.858 2.114-2.393 2.114zm35.627 7.685H60.35V0h2.416l5.193 8.015L73.129 0h2.574v14.071h-2.62V4.712l-4.763 7.245h-.7L62.99 4.778v9.293zM96 11.913v2.158H83.086V0H95.57v2.202H85.75v3.391h5.87V7.84h-5.87v4.074H96z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v14H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92ce7f13da173e042744f73189643533.svg";
export { ForwardRef as ReactComponent };